import React, { forwardRef, useEffect, useRef, useState } from "react";
import instance from "../../util/axios";
import { Result } from "../../schema";
import { Description } from "../schema";
import { Accordion, Button, Modal, Toast } from "antd-mobile";
import axios from "../../util/axios";
import Grid from "../Grid";
import { useLocation } from "react-use";

interface VSheetProps {
  workflowTemplateId: string;
  dataId?: string;
}

export default forwardRef(
  ({ workflowTemplateId, dataId }: VSheetProps, ref: any) => {
    const [descriptions, setDescriptions] = useState<Description[]>([]);
    const [data, setData] = useState<{ [key: string]: any }>();
    const [formName, setFormName] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [currentData, setCurrentData] = useState<{ [key: string]: any }>();
    const [details, setDetails] = useState<
      {
        data: {
          descriptions: Description[];
          data: { [key: string]: any };
        }[];
        title: string;
      }[]
    >();
    const [currentDetails, setCurrentDetails] = useState<
      {
        data: {
          descriptions: Description[];
          data: { [key: string]: any };
        }[];
        title: string;
      }[]
    >();
    const loact = useLocation();
    useEffect(() => {
      (async () => {
        const resp = await instance.get<
          Result<{
            description: Description[];
            data: { [key: string]: any };
            form: { [key: string]: any };
            details: {
              data: {
                descriptions: Description[];
                data: { [key: string]: any };
              }[];
              title: string;
            }[];
          }>
        >(
          `/wf/formMobile/data?workflowTemplateId=${workflowTemplateId}&id=${dataId}`
        );
        console.log("vsheet", resp);
        if (resp.data.Status !== "1") return;
        setFormName(resp.data.Data.form["formName"]);
        setDescriptions(resp.data.Data.description);
        //主区域
        // console.log(resp.data.Data.details[0].data[0]);
        console.log(loact.state.state.pageDatas);
        // console.log(resp.data.Data.details);
        if (loact.state.state.pageDatas !== undefined) {
          loact.state.state.pageDatas.forEach((pageData: any) => {
            for (const pageName of Object.keys(pageData.key)) {
              //主表字段带入
              for (const dataName of Object.keys(resp.data.Data.data)) {
                if (dataName === pageName) {
                  resp.data.Data.data[dataName] = pageData.key[pageName];
                }
              }
              // 明细表字段带入;
              if (pageData.name !== undefined) {
                resp.data.Data.details.forEach((detail) => {
                  if (detail.title !== pageData.name) return;

                  for (let i = 0; i < detail.data.length; i++) {
                    const data = detail.data[i];
                    if (data.data === pageData.key) break;

                    console.log(
                      data.data,
                      pageData.key,
                      data.data === pageData.key,
                      pageData
                    );
                    data.data = pageData.key;
                  }
                });
              }
            }
          });
        }
        console.log(resp.data.Data.details);
        setData(resp.data.Data.data);

        setCurrentData(resp.data.Data.data);
        //明细
        setDetails(resp.data.Data.details);
        setCurrentDetails(resp.data.Data.details);
      })();
    }, [dataId, loact.state.state.pageDatas, workflowTemplateId]);
    const gridRef = useRef<any>(null);
    return (
      <>
        {data && descriptions.length > 0 && (
          <Grid
            ref={gridRef}
            descriptions={descriptions}
            data={data}
            onChange={(currentData) => {
              setCurrentData(currentData);
            }}
          />
        )}
        {details &&
          details.map((detail, detailsIndex) => (
            <>
              <Accordion>
                <Accordion.Panel header={details[detailsIndex].title}>
                  {detail.data.map((data, detailIndex) => (
                    <>
                      <Accordion>
                        <Accordion.Panel
                          header={
                            <div
                              style={{
                                width: "100%",
                                display: "inline-flex",
                                justifyContent: "space-between",
                              }}
                            >
                              明细 {detailIndex + 1}
                              <button
                                type="button"
                                style={{
                                  paddingRight: "20px",
                                  border: "none",
                                  backgroundColor: "transparent",
                                  color: "#108ee9",
                                }}
                                onClick={() => {
                                  Modal.alert("提示", "是否确认删除", [
                                    {
                                      text: "取消",
                                      onPress: () => {},
                                    },
                                    {
                                      text: "确定",
                                      onPress: () => {
                                        setDetails((prevState) => {
                                          if (!prevState) return;
                                          const cloned = [...prevState];
                                          if (
                                            cloned[detailsIndex].data.length ===
                                            1
                                          ) {
                                            Toast.success("至少需要一条明细");
                                            return prevState;
                                          }

                                          cloned[detailsIndex].data.splice(
                                            detailIndex,
                                            1
                                          );
                                          return cloned;
                                        });
                                      },
                                    },
                                  ]);
                                }}
                              >
                                删除
                              </button>
                            </div>
                          }
                        >
                          <Grid
                            ref={gridRef}
                            descriptions={data.descriptions}
                            type={"detail"}
                            data={data.data}
                            onChange={(currentDetails) => {
                              setCurrentDetails((prevState) => {
                                if (!prevState) return;
                                [...prevState][detailsIndex].data[
                                  detailIndex
                                ].data = currentDetails;
                                return prevState;
                              });
                            }}
                          />
                        </Accordion.Panel>
                      </Accordion>
                    </>
                  ))}
                  <div
                    style={{
                      width: "100%",
                      display: "inline-flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      inline
                      size="small"
                      style={{ color: "#108ee9", marginRight: "4px" }}
                      onClick={() => {
                        setDetails((prevState) => {
                          if (!prevState) return;
                          const cloned = [...prevState];
                          cloned[detailsIndex].data.splice(
                            detailsIndex,
                            0,
                            prevState[detailsIndex].data[0]
                          );
                          return cloned;
                        });
                      }}
                    >
                      增加明细
                    </Button>
                  </div>
                </Accordion.Panel>
              </Accordion>
            </>
          ))}
        <Button
          loading={loading}
          type="primary"
          onClick={async () => {
            if (gridRef.current && !gridRef.current.validate()) {
              Toast.info("请填写必填项", 1);
              return;
            }

            //清空无数据的明细
            if (!currentDetails) {
              return;
            }
            let cloned = [...currentDetails];
            for (let i = 0; i < currentDetails.length; i++) {
              let currentDetail = currentDetails[i].data;
              for (let j = 0; j < currentDetail.length; j++) {
                let fields = currentDetail[j].data;
                let flag = false;
                for (let value in fields) {
                  //ToDo增加对序号的筛选
                  if (value !== "uuid" && fields[value] !== "") {
                    flag = true;
                    break;
                  }
                }
                if (!flag) {
                  //清空无数据明细
                  cloned[i].data.splice(j, 1);
                }
              }
            }

            setLoading(true);
            const resp = await axios.post("/wf/formMobile/saveData", {
              data: JSON.stringify(currentData),
              details: JSON.stringify(cloned),
              workflowTemplateId: workflowTemplateId,
            });
            if (resp.data.Status !== "1") {
              setLoading(false);
              Toast.success("保存失败", 1);
              return;
            }
            Toast.success("保存成功", 1);

            Modal.alert("提示", "保存成功,是否提交审批", [
              {
                text: "取消",
                onPress: () => {
                  setLoading(false);
                },
              },
              {
                text: "确定",
                onPress: async () => {
                  const submit = await axios.post("/wf/form/vsheet/submit", {
                    id: resp.data.Data,
                    name: formName,
                    version: "默认",
                  });
                  if (submit.data.Status === "1") {
                    Toast.success("提交成功", 1);
                  } else {
                    Toast.success("提交失败，请联系管理员", 1);
                  }
                  setLoading(false);
                },
              },
            ]);
          }}
        >
          提交
        </Button>
      </>
    );
  }
);
